import React from 'react'

// Events without an uploaded banner used to fall back to noimage.png - a
// generic round user-avatar silhouette meant for profile photos. Stretched
// across a rectangular event banner slot it reads as a broken photo, not a
// deliberate "no image yet" state. This renders an explicit placeholder
// instead, taking the same className/style as the <img> it replaces so it
// fills the identical box. `compact` drops the label for small thumbnails
// (e.g. a circular avatar-sized slot) where the full text can't fit.
const EventImagePlaceholder = ({ className, style, compact = false }) => (
    <div
        className={className}
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#eef1f4',
            color: '#9aa3ab',
            ...style,
        }}
    >
        <i className="ri-calendar-2-line" style={{ fontSize: compact ? '18px' : '28px', lineHeight: 1 }}></i>
        {!compact && <span style={{ fontSize: '11px', marginTop: '6px' }}>No image available</span>}
    </div>
)

export default EventImagePlaceholder
